// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalPreRelease } from './GlobalPreRelease';
import {
  GlobalPreReleaseFromJSON,
  GlobalPreReleaseFromJSONTyped,
  GlobalPreReleaseToJSON,
  GlobalPreReleaseToJSONTyped,
} from './GlobalPreRelease';
import type { RegionalPreRelease } from './RegionalPreRelease';
import {
  RegionalPreReleaseFromJSON,
  RegionalPreReleaseFromJSONTyped,
  RegionalPreReleaseToJSON,
  RegionalPreReleaseToJSONTyped,
} from './RegionalPreRelease';

/**
 * Pre-release access state for one organization, as returned by the list endpoint. The two scopes are independent and a row may show both at once: global_pre_release is absent when the organization has no global grant; regional_pre_release is an empty array when it has no per-region grants.
 *
 * @export
 * @interface AdminOrganization
 */
export interface AdminOrganization {
  /**
   *
   * @type {string}
   * @memberof AdminOrganization
   */
  orgId: string;
  /**
   *
   * @type {GlobalPreRelease}
   * @memberof AdminOrganization
   */
  globalPreRelease?: GlobalPreRelease;
  /**
   *
   * @type {Array<RegionalPreRelease>}
   * @memberof AdminOrganization
   */
  regionalPreRelease: Array<RegionalPreRelease>;
}

/**
 * Check if a given object implements the AdminOrganization interface.
 */
export function instanceOfAdminOrganization(
  value: object,
): value is AdminOrganization {
  if (!('orgId' in value) || value['orgId'] === undefined) return false;
  if (
    !('regionalPreRelease' in value) ||
    value['regionalPreRelease'] === undefined
  )
    return false;
  return true;
}

export function AdminOrganizationFromJSON(json: any): AdminOrganization {
  return AdminOrganizationFromJSONTyped(json, false);
}

export function AdminOrganizationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdminOrganization {
  if (json == null) {
    return json;
  }
  return {
    orgId: json['org_id'],
    globalPreRelease:
      json['global_pre_release'] == null
        ? undefined
        : GlobalPreReleaseFromJSON(json['global_pre_release']),
    regionalPreRelease: (json['regional_pre_release'] as Array<any>).map(
      RegionalPreReleaseFromJSON,
    ),
  };
}

export function AdminOrganizationToJSON(json: any): AdminOrganization {
  return AdminOrganizationToJSONTyped(json, false);
}

export function AdminOrganizationToJSONTyped(
  value?: AdminOrganization | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    org_id: value['orgId'],
    global_pre_release: GlobalPreReleaseToJSON(value['globalPreRelease']),
    regional_pre_release: (value['regionalPreRelease'] as Array<any>).map(
      RegionalPreReleaseToJSON,
    ),
  };
}
